module.exports = __webpack_public_path__ + "static/media/logo.677f6d79.jpg";